export const WSEvents = {
  CONNECTING: 'ws-connecting',
  CONNECTED: 'ws-connected',
};
